//   COMPANY NAME
//  FOR LOCAL USE
const SERVER_IP = "localhost";
const SERVER_PORT = "8000";
export const UTILITY_SERVER_URL =  "https://print.techiteasy.co.in";
export const PRINT_SERVER_URL =  "https://print.techiteasy.co.in";
export const QR_SERVER_URL =  "https://print.techiteasy.co.in";
export const FRONTEND_BILTY_PRINT = 0

// export const TRANSPORTER_NAME = "SARAL TRANSPORT"
// export const TRANSPOTER_GSTIN = "22AAAAA0000A1Z5"
// // export const SERVER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT;
// export const SERVER_URL = "http://103.36.80.249:8000"

export const TRANSPORTER_NAME = "JAY JAGDISH TRANSPORT SERVICE"
export const TRANSPOTER_GSTIN = "24AAGFJ8501M1Z8"
export const SERVER_URL = "https://backend.jjts.in"

// export const TRANSPORTER_NAME = "SAI ROADLINES"
// export const TRANSPOTER_GSTIN = "24AQUPM9804G1ZE"
// export const SERVER_URL = "http://103.1.100.173:8002"

// export const TRANSPORTER_NAME = "SHREE JAGDISH TRANSPORT SERVICE"
// export const TRANSPOTER_GSTIN = "24ALSPG4310Q2ZR"
// export const SERVER_URL = "http://103.1.100.173:8003"

// export const TRANSPORTER_NAME = "CITY ROADLINES"
// export const TRANSPOTER_GSTIN = "24AINPJ2407K1ZA"
// export const SERVER_URL = "http://103.1.100.173:8004"


